import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import ReactList from 'react-list'

import { teamCalendarSelector } from '../../../selectors'

import { GroupHeaderRow } from './group-header-row'
import { DataRow } from './data-row'

export const Group = (props) => {
  const openedItems = useSelector(teamCalendarSelector.getOpenedItems)

  const {
    group,
    dates,
    publicHolidays,
    teamCalendar,
    onGroupHeaderClick,
  } = props
  const isHidden = !openedItems[group.id]

  const renderItem = (index) => {
    return (
      <DataRow
        key={ `group-${index}` }
        teamCalendar={ teamCalendar }
        row={ Object.entries(group.rows)[index][1] }
        dates={ dates }
        publicHolidays={ publicHolidays }
      />
    )
  }

  return (
    <Root>
      <GroupHeaderRow
        group={ group }
        isHidden={ isHidden }
        teamCalendar={ teamCalendar }
        onGroupHeaderClick={ onGroupHeaderClick }
      />
      { !isHidden && (
        <Wrapper>
          <ReactList
            itemRenderer={ renderItem }
            length={ Object.keys(group.rows).length }
          />
        </Wrapper>
      )}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
`

const Wrapper = styled.div`
  display: block;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/group.js